import { render, staticRenderFns } from "./newRole.vue?vue&type=template&id=2755043c&scoped=true&"
import script from "./newRole.vue?vue&type=script&lang=js&"
export * from "./newRole.vue?vue&type=script&lang=js&"
import style0 from "./newRole.vue?vue&type=style&index=0&id=2755043c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2755043c",
  null
  
)

export default component.exports